var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-feed"},[_c('Mark',{attrs:{"label":_vm.author,"value":_vm.name,"BGL":"#24292e","BGR":_vm.color},nativeOn:{"click":function($event){return _vm.copy(_vm.author + '#' + _vm.name)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }